import { render } from "./ViewCompetition.vue?vue&type=template&id=77cc82a4&scoped=true"
import script from "./ViewCompetition.vue?vue&type=script&lang=js"
export * from "./ViewCompetition.vue?vue&type=script&lang=js"

import "./ViewCompetition.vue?vue&type=style&index=0&id=77cc82a4&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cc82a4"]])

export default __exports__